import { render } from "./SolutionReport.vue?vue&type=template&id=3664fa33&scoped=true"
import script from "./SolutionReport.vue?vue&type=script&lang=js"
export * from "./SolutionReport.vue?vue&type=script&lang=js"

import "./SolutionReport.vue?vue&type=style&index=0&id=3664fa33&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3664fa33"]])

export default __exports__